import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import Navbar from './Navbar';

const { Content } = Layout;

const ProtectedLayout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <Layout 
      style={{ 
        minHeight: '100vh',
        background: '#0d1117',
        color: '#e6edf3'
      }}
    >
      <Navbar />
      <Content style={{ 
        padding: isMobile ? 12 : 24,
        background: '#0d1117',
        color: '#e6edf3',
        minHeight: 'calc(100vh - 64px)'
      }}>
        {children}
      </Content>
    </Layout>
  );
};

export default ProtectedLayout;
